module.exports = __webpack_public_path__ + "static/img/10.f200d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/10.png
// module id = 8FCI
// module chunks = 57